/**
 * Approved photography.
 *
 * Only client-supplied, approved images go here. Anything still pending stays empty
 * and the UI falls back to a clearly labeled placeholder block.
 *
 * Never apply a color overlay, duotone, gradient scrim, or heavy filter to these photos.
 */

/**
 * GC monogram. Client-supplied.
 * NOTE: this file has an opaque white background, so BrandLogo blends it out with
 * mix-blend-mode. Replace it with a transparent PNG or an SVG when one is available.
 */
export const BRAND_LOGO = 'https://cdn.magicpatterns.com/uploads/eYRaxJ7qgLRFabBFomSiJd/Screenshot_2026-08-07_at_2.39.52_PM.png'

/** Hero — Gabriela + Chanira. Pending the approved horizontal, natural-daylight shot. */
export const HERO_PHOTO = ''

/**
 * Vehicle image shown beside the hero copy on desktop only. Decorative support for the
 * headline — it fills the right column, it is not a claim about inventory.
 * Hidden on mobile, where the headline and CTA must own the first screen.
 */
export const HERO_VEHICLE = 'https://cdn.magicpatterns.com/uploads/7snRKjt7GYgszw4nSVHM6G/image.png'

/**
 * The single shared photo of both Queens.
 * Gabriela is on the LEFT (blonde). Chanira is on the RIGHT (dark curly hair).
 */
export const QUEENS_PHOTO = 'https://cdn.magicpatterns.com/uploads/uRPXDd1yZEaEpBMViyF5UN/image.png'

/**
 * Clean vertical photo of both Queens — no baked-in poster text, logos, or icons.
 * Gabriela on the LEFT, Chanira on the RIGHT.
 *
 * Used as the mobile portrait, where its 9:16 framing belongs, and shown as an
 * editorial vertical on desktop beside the bios.
 */
export const QUEENS_PHOTO_MOBILE =
  'https://cdn.magicpatterns.com/uploads/ggggLYSNW2B3n2nwma86aA/image.png'

/** Closing block photo — pending. */
export const FINAL_PHOTO = ''
